/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Tilføj til ordre",
  "i18n.additionalProducts.emotionalHook": "♥️ Bestseller:",
  "i18n.additionalProducts.productDescription": "Produktbeskrivelse",
  "i18n.additionalProducts.showMore": "Yderligere oplysninger",
  "i18n.additionalProducts.title": "Passende tilbehør",
  "i18n.button.addToCart": "Føj til indkøbskurv",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Anvend",
  "i18n.button.back": "Tilbage",
  "i18n.button.cancel": "Annuller",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Luk",
  "i18n.button.continue": "Fortsæt",
  "i18n.button.ignore": "Ignorer",
  "i18n.button.ignoreAndContinue": "Fortsæt alligevel",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst",
  "i18n.button.noChanges": "Nej tak, luk vindue",
  "i18n.button.design": "",
  "i18n.button.photos": "Billeder",
  "i18n.button.retry": "Prøv igen",
  "i18n.button.uploadPhotos": "Upload billede(r)",
  "i18n.button.withSmartSorted": "Upgrade til SMART SORTED ",
  "i18n.button.withoutSmartSorted": "Nej tak, luk vindue",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "For at få en bedre læsbarhed, skal du forkorte længden af teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Den valgte skrifttype er for stor til denne tekst.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Den maksimale skriftstørrelse for denne tekst er nået.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Den minimale skriftstørrelse for denne tekst er nået.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Indsæt venligst et linjeskift",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Fortsæt med at skrive på en anden linje eller ødelæg tekstfeltet.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Kontrollér din tekst, ikke alle tegn understøttes af denne skrifttype.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "For at få en bedre læsbarhed, skal du forkorte længden af teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Hvis du venligst gøre tekstfeltet større",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Denne ændring kan ikke fortrydes",
  "i18n.dialog.deletePlaceholder.title": "Slette plads holderen?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Opløsningen på dette billede er for lav til at trykke motivet optimalt!",
  "i18n.dialog.smartSorted.message": "Med SMART SORTED lægger I jeres puslespilsmotiv med 1000 brikker på en innovativ og ubesværet måde, også uden skabelon af motivet",
  "i18n.dialog.smartSorted.title": "En garanteret succesoplevelse med dit puslespil",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klik på \"{{text}}\", for at ændre æskens titel.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Æskens titel er ikke blevet ændret.",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Fortsæt uden en titel på æsken",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "En pladsholder er ikke blevet ændret",
    "Flere pladsholdere er ikke blevet ændret."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "uændrede pladsholdere",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Du afbrød oprettelsen i længere tid. Den kan ikke fortsættes. Start venligst processen igen.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Et billede kunne ikke indlæses.  Det blev fjernet fra designområdet og galleriet.",
  "i18n.error.imageLoadingError.title": "Downloadfejl",
  "i18n.error.imageProvisionError.message": "Ét eller flere billeder kunne ikke behandles. Medietypen er sandsynligvis ikke understøttet",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Filen \"{{reference1}}\" kunne ikke behandles",
  "i18n.error.imageSelectionError.title": "Fejl under overførsel af billede",
  "i18n.error.imageSizeLimitExceededError.message": "Det billedede, som du har uploaded, er for stor. \nVenligst sørg for, at billedet har en maksimal størrelse på 180 megapixels og prøv igen.",
  "i18n.error.imageSizeLimitExceededError.title": "Fejl under overførsel af billede",
  "i18n.error.imageUploadError.message": "Der opstod et problem med internetforbindelsen.\nPrøv igen senere.",
  "i18n.error.imageUploadError.title": "Fejl under overførsel af billede",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Denne skrifttype er ikke relevant, vælg venligst en anden skrifttype.",
  "i18n.error.invalidCharConfigError.title": "Skrifttype ikke relevant",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Din internetforbindelse er blevet afbrudt. Du kan fortsætte med at designe dit produkt, så snart din forbindelse er blevet genoprettet.",
  "i18n.error.templateLoadingError.message": "Skabelonen \"{{ error.reference[0] }}\" kunne ikke indlæses.\nPrøv igen senere.",
  "i18n.error.templateLoadingError.title": "Downloadfejl",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" har en ikke-understøttet medietype.",
  "i18n.error.unsupportedMediaTypeError.title": "Fejl under overførsel af billede",
  "i18n.error.uploadProductError.message": "Et eller flere produkter kunne ikke overføres til serveren. Prøv igen senere.",
  "i18n.error.uploadProductError.title": "Fejl under overførsel",
  "i18n.error.zoomModeError.message": "Teksten fra dit tidligere layout kunne ikke vedtages. Indtast venligst en ny tekst.",
  "i18n.error.zoomModeError.title": "Tekst ikke vedtaget",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Pris",
  "i18n.price.reduction": "Du sparer",
  "i18n.price.total": "Pris i alt",
  "i18n.priceDisplay.times": [
    "{{value}} produkt til {{pricePerUnit}} hver",
    "{{value}} produkter til {{pricePerUnit}} hver"
  ],
  "i18n.progress.stepAdditionalProducts": "Vælg tilbehør",
  "i18n.progressOverlay.message.lines.one": "Tak for dit design",
  "i18n.progressOverlay.message.lines.two": "Vi forbereder følgende trin for dig ...",
  "i18n.template.insertText": "Indtast din tekst her",
  "i18n.toolbox.image.title": "Rediger billede",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 billede",
    "{{value}} billeder"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D-forhåndsvisning",
  "i18n.toolbox.productChooser.title": "Skift produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Rediger tekst",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleDaDK {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
